module.exports = __webpack_public_path__ + "img/Chart-Bar-Color.5974f898.png";